module.exports = __webpack_public_path__ + "static/media/ml.fa46e43f.svg";